import { gql } from '@apollo/client'
import { ParkingSubscriptionStatus } from '../tenant/getTenant'

export const CANCELLED_SUBSCRIPTIONS_LIMIT = 60

export interface ICancelledDaySlot {
  day: string
  cancelledAt?: string | null
  cancelledBy?: string | null
  poolParking?: {
    parking?: {
      name: string
    } | null
  } | null
}

export interface ICancellableSubscription {
  id: string
  validFrom: string
  validTo: string
  status: ParkingSubscriptionStatus
  cancelledAt?: string | null
  cancelledBy?: string | null
  parkingPass?: {
    parking?: {
      name: string
    } | null
  } | null
  cancelledDays?: ICancelledDaySlot[] | null
}

export interface IQueryUserCancelledReservationsVars {
  login: string
  first: number
}

export interface IQueryUserCancelledReservationsData {
  queryUser: {
    login: string
    parkingSubscriptions: ICancellableSubscription[]
  }[]
}

export const QUERY_USER_CANCELLED_RESERVATIONS = gql`
  query queryUserCancelledReservations($login: String!, $first: Int!) {
    queryUser(filter: { login: { eq: $login } }) {
      login
      parkingSubscriptions: parking_subscriptions(
        filter: { type: { eq: TenantParkingPool } }
        order: { desc: valid_from }
        first: $first
      ) {
        id
        validFrom: valid_from
        validTo: valid_to
        status
        cancelledAt: cancelled_at
        cancelledBy: cancelled_by
        parkingPass: parking_pass {
          parking {
            name
          }
        }
        cancelledDays: day_slots(
          filter: { status: { eq: cancelled } }
          order: { asc: day }
        ) {
          day
          cancelledAt: cancelled_at
          cancelledBy: cancelled_by
          poolParking: pool_parking {
            parking {
              name
            }
          }
        }
      }
    }
  }
`
